import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/HomeClient.tsx");
